/* Lumoss — interactions minimales */
(function () {
  var open = document.querySelector('[data-menu-open]');
  var drawer = document.getElementById('menu-drawer');
  if (open && drawer) {
    var close = drawer.querySelector('[data-menu-close]');
    var show = function (state) {
      drawer.classList.toggle('is-open', state);
      document.body.style.overflow = state ? 'hidden' : '';
      open.setAttribute('aria-expanded', state ? 'true' : 'false');
      if (state) { (close || drawer).focus(); } else { open.focus(); }
    };
    open.addEventListener('click', function () { show(true); });
    if (close) close.addEventListener('click', function () { show(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) show(false);
    });
  }

  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');

    var sync = function () {
      var chosen = Array.prototype.map.call(
        form.querySelectorAll('input[type=radio]:checked'),
        function (i) { return i.value; }
      ).join(' / ');
      var match = variants.filter(function (v) { return v.title === chosen; })[0] || variants[0];
      if (!match) return;
      idField.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.dataset.addLabel : 'Épuisé';
      }
    };
    form.addEventListener('change', sync);
    sync();
  });
})();
